import React, { Component } from "react";
import Quagga from "quagga";
import { BarLoader } from "react-spinners";
import "./index.css";
import isMobile from "ismobilejs";

class BarcodeScanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      detected: false,
      code: null,
      scannerInitialising: false
    };

    this._detect = this._detect.bind(this);
    this._quaggaInit = this._quaggaInit.bind(this);
  }

  componentDidMount() {
    this._quaggaInit();
  }

  componentDidUpdate(prevProps, prevState) {
    const { watching } = this.props;
    if (prevProps.watching && !watching) {
      Quagga.stop();
    } else if (!prevProps.watching && watching) {
      if (
        navigator.mediaDevices &&
        typeof navigator.mediaDevices.getUserMedia === "function"
      ) {
        this._quaggaInit();
      } else {
        alert("Devices does not support accessing media device");
      }
    }
  }

  componentWillUnmount() {
    Quagga.stop();
  }

  _quaggaInit() {
    this.setState({ scannerInitialising: true });
    let init = (error = false) => {
      this.setState({ scannerInitialising: false, error });
    };

    init = init.bind(this);

    Quagga.init(
      {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          constraints: {
            width: isMobile.android.device ? 600 : { min: 640 },
            height: isMobile.android.device ? 360 : { min: 480 },
            facingMode: "environment",
            aspectRatio: { min: 1, max: 2 }
          }
        },
        decoder: {
          readers: ["code_128_reader", "code_39_reader"]
        },
        numOfWorkers: 2,
        locate: false,
        frequency: 10,
        locator: {
          halfSample: true,
          patchSize: "medium" // x-small, small, medium, large, x-large
        }
      },
      function(err) {
        if (err) {
          init(err);
          return console.log(err);
        }
        init();
        Quagga.start();
      }
    );
    Quagga.onDetected(this._detect);
    Quagga.onProcessed(this._process);
  }

  _process(result) {
    var drawingCtx = Quagga.canvas.ctx.overlay,
      drawingCanvas = Quagga.canvas.dom.overlay;
    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(
          0,
          0,
          parseInt(drawingCanvas.getAttribute("width"), 10),
          parseInt(drawingCanvas.getAttribute("height"), 10)
        );
        result.boxes
          .filter(box => box !== result.box)
          .forEach(box => {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: "green",
              lineWidth: 2
            });
          });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
          color: "#00F",
          lineWidth: 2
        });
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(
          result.line,
          { x: "x", y: "y" },
          drawingCtx,
          { color: "red", lineWidth: 3 }
        );
      }
    }
  }

  _detect(result) {
    this.props.onDetect(result);
  }

  render() {
    const { code, scannerInitialising, error } = this.state;
    return (
      <div>
        {error && <p>Error: {JSON.stringify(error)}</p>}
        {scannerInitialising && (
          <div className="scanner-loader">
            <BarLoader width={200} color={"var(--primary-color)"} />
          </div>
        )}
        <div id="interactive" className="viewport" />
        {code && JSON.stringify(code)}
      </div>
    );
  }
}

export default BarcodeScanner;



// WEBPACK FOOTER //
// ./src/components/barcode-scanner/index.js